















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { Option } from "../../models/Option";
import { ListParamApi } from "../../api/ListParamApi";

export default {
    name: "ContactListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            initComplete: false,
            filters: {},
            ListParamApi: new ListParamApi(),
            columns: [
                {
                    id: "type_id",
                    name: "Type",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "type.name",
                },
                {
                    id: "nom",
                    name: "Nom",
                    type: TableColumn.ColumnType.text,
                    sort_field: "nom",
                    default_sort: true,
                },
                {
                    id: "adresse.adresse",
                    name: "Adresse",
                    type: TableColumn.ColumnType.text,
                    sort_field: "adresse.adresse",
                },
                {
                    id: "adresse.code_postal",
                    name: "Code Postal",
                    type: TableColumn.ColumnType.text,
                    sort_field: "adresse.code_postal",
                },
                {
                    id: "adresse.ville",
                    name: "Ville",
                    type: TableColumn.ColumnType.text,
                    sort_field: "adresse.ville",
                },
                {
                    id: "telephone",
                    name: "Téléphone",
                    type: TableColumn.ColumnType.text,
                    sort_field: "telephone",
                },
                {
                    id: "email",
                    name: "Email",
                    type: TableColumn.ColumnType.text,
                    sort_field: "coordonnees.email",
                },
                {
                    id: "category_id",
                    name: "Catégorie",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                },
                {
                    id: "archived",
                    name: "Archivé",
                    type: TableColumn.ColumnType.boolean,
                    sort_field: "archived",
                    default_filter: true,
                    default_value: false,
                },
                {
                    id: "created_at",
                    name: "Date d'ajout",
                    sort_field: "created_at",
                },
            ],
        };
    },
    created() {
        let self = this;
        self.ListParamApi.getAll({
            type: Option.EListParamType.category_client,
        }).then(function (res) {
            let col = _.find(self.columns, { id: "category_id" });
            col.options = Option.toTags(Option.arrToOptions(res));
        });
    },
    beforeMount() {
        let self = this;
        // Load client types for the type filter
        self.ListParamApi.getAll({
            type: Option.EListParamType.type_client,
        }).then(function (res) {
            let col = _.find(self.columns, { id: "type_id" });
            col.options = Option.toTags(Option.arrToOptions(res));
            if (self.defaultFilters) {
                if (self.defaultFilters.has("types")) {
                    let types = self.defaultFilters.get("types");

                    let defaultTypes = _.filter(col.options, function (option) {
                        return _.includes(types, option.text);
                    });
                    if (defaultTypes.length > 0) {
                        col.default_filter = true;

                        col.default_value = defaultTypes;
                    }
                }
            }
            self.initComplete = true;
        });
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
            this.$emit("input", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            return _.merge({}, this.filters);
        },
    },
};
